/** Shared panel constants (one home instead of per-page copies). */

/** SortableTh has no rule of its own; add this so headers carry the design `.tbl th` bottom border. */
export const TH_RULE = 'border-b border-line';

/** Pass mark (%) used to tone scores and draw the pass line across the panel. */
export const PASS_MARK = 50;
